import React, { useEffect, useState, useRef } from "react";
import "./OurImpact.css";
import axios from "axios";
import Loading from "../../Components/Loading/Loading";
import ProjectSliders from "../../Components/ProjectsSlider/ProjectSliders";

function OurImpact() {
  const [impact, setImpact] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isFetchedImpact = useRef(false); // ✅ Prevents duplicate API call

  useEffect(() => {
    if (!isFetchedImpact.current) {
      fetchImpact();
      isFetchedImpact.current = true; // ✅ Ensure it runs only once
    }
  }, []);

  const fetchImpact = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}api/OurImpacts`
      );
      const sortedContent = Array.isArray(response.data)
        ? [...response.data].sort((a, b) => a.sortOrder - b.sortOrder)
        : [];
      setImpact(sortedContent);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  if (loading) return <Loading />;
  if (error) return <p>Error: {error}</p>;

  const images = [
    "/images/websiteelements-05.svg",
    "/images/websiteelements-04.svg",
    "/images/websiteelements-07.svg",
    "/images/websiteelements-06.svg",
  ];
  const hoverImages = [
    "/images/websiteelements-11.svg",
    "/images/websiteelements-10.svg",
    "/images/websiteelements-14.svg",
    "/images/websiteelements-13.svg",
  ];
  return (
    <div className="ourimpact-container">
      <h1>OUR IMPACT</h1>
      <div className="ourimpact-content-list desktop-versionimpact">
        {impact.map((item, index) => (
          <div
            key={index}
            className={`content-item ${
              index % 2 === 0 ? "left" : "right"
            } impactitem-${index + 1}`}
          >
            {/* Conditionally swap the order of text and image */}
            {index % 2 === 0 ? (
              <div className="text-container">
                <h2>{item.title}</h2>
                <p
                  className="p-content-text"
                  dangerouslySetInnerHTML={{
                    __html: item.description,
                  }}
                />
              </div>
            ) : (
              <div className="image-container">
                <img
                  className="defaultimage"
                  src={images[index % images.length]}
                  alt={`Design ${index}`}
                />
                <img
                  src={hoverImages[index % hoverImages.length]}
                  alt={`Design ${index}`}
                  className="HoverImage"
                />
              </div>
            )}

            {index % 2 === 0 ? (
              <div className="image-container">
                <img
                  src={images[index % images.length]}
                  className="defaultimage"
                  alt={`Design ${index}`}
                />
                <img
                  className="HoverImage"
                  src={hoverImages[index % hoverImages.length]}
                  alt={`Design ${index}`}
                />
              </div>
            ) : (
              <div className="text-container">
                <h2>{item.title}</h2>
                <p
                  className="p-content-text"
                  dangerouslySetInnerHTML={{
                    __html: item.description,
                  }}
                />
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="ourimpact-content-list mobile-versionimpact">
        {impact.map((item, index) => (
          <div key={index} className="content-item">
            <div className="text-container">
              <h2>{item.title}</h2>
              <p
                className="p-content-text"
                dangerouslySetInnerHTML={{
                  __html: item.description,
                }}
              />
            </div>
          </div>
        ))}
      </div>
      <h2 className="ourwork-title">OUR WORK</h2>
      <ProjectSliders />
    </div>
  );
}

export default OurImpact;
